<div *ngIf="showOverlay" class="overlay">
  <div class="gif-container">
    <img src="assets/gifs/done.gif" alt="Done" class="gif" />
  </div>
</div>
